import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import FormText from './FormText.js';
import ConfirmPopup from './ConfirmPopup.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function LinksEdit({showEdit, closeEdit, updateLinksRowEdit, updateLinksRowDelete, data}) {
	const popupAnimationMs = 300;
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState('');
	const [URL, setURL] = useState('');
	const [groupName, setGroupName] = useState('');
	const [nameError, setNameError] = useState('');
	const [URLError, setURLError] = useState('');
	const [groupNameError, setGroupNameError] = useState('');
	const [showConfirmPopup, setShowConfirmPopup] = useState(false);

	const nameRef = useRef(null);
	const URLRef = useRef(null);
	const groupNameRef = useRef(null);
	const {shouldRender, isClosing} = usePopupAnimation(showEdit, popupAnimationMs);

	useEffect(() => {
		setName(data.NAME || '');
		setURL(data.URL || '');
		setGroupName(data.GROUPNAME || '');
		setNameError('');
		setURLError('');
		setGroupNameError('');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showEdit]);

	useEffect(() => {
		setName(data.NAME || '');
		setURL(data.URL || '');
		setGroupName(data.GROUPNAME || '');
		setNameError('');
		setURLError('');
		setGroupNameError('');
	}, [data]);

	const handleSubmit = (e) => {
		e.preventDefault();

		setNameError('');
		setURLError('');
		setGroupNameError('');

		let localError = 0;

		if (!name) {
			localError = 1;
			setNameError('povinné');
			nameRef.current.focus();
		}

		if (localError === 0) {
			setLoading(true);

			post('saveLinksOld', {NAME: name, URL: URL, GROUPNAME: groupName, ID: data.ID})
				.then((res) => {
					closeEdit();
					updateLinksRowEdit({ID: data.ID, NAME: name, URL: URL, GROUPNAME: groupName});
					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	const handleConfirmPopup = (e) => {
		e.preventDefault();
		setShowConfirmPopup(true);
	};

	const closeConfirmPopup = () => {
		setShowConfirmPopup(false);
	};

	const deleteConfirmPopup = () => {
		setLoading(true);

		post('deleteLinks', {ID: data.ID})
			.then((res) => {
				closeConfirmPopup();
				closeEdit();
				updateLinksRowDelete(data.ID);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	return (
		<>
			<ConfirmPopup showConfirmPopup={showConfirmPopup} showButtonDelete deleteConfirmPopup={deleteConfirmPopup} closeConfirmPopup={closeConfirmPopup} infoHeader="Smazání záznamu" infoMain="Opravdu chceš smazat tento záznam?" />

			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit}>
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">Editace odkazu</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeEdit();
									}}
								/>
							</div>
							<div className="popup_content_in_body">
								<div className="popup_content_in_body_in">
									<FormText type="text" label="Název" height="25rem" value={name} setValue={setName} ref={nameRef} error={nameError} />
									<FormText type="text" label="URL" height="25rem" value={URL} setValue={setURL} ref={URLRef} error={URLError} />
									<FormText type="text" label="Skupina odkazů" height="25rem" value={groupName} setValue={setGroupName} ref={groupNameRef} error={groupNameError} />
									<div className="zero h0" />
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={loading} />
									<button
										type="button"
										className="button red mr_2"
										onClick={(e) => {
											handleConfirmPopup(e);
										}}
									>
										Smazat
									</button>
									<button
										type="button"
										className="button"
										onClick={() => {
											closeEdit();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
